import {
    IUserMe,
} from 'entities/users/types';

import {
    PERMISSION,
} from 'entities/users/constants';
import {
    isAdmin,
} from 'entities/users/functions';

import {
    PATH,
} from 'pages/constants';

export function onUnauthorized() {
    window.location.replace('/');
}

export function getStartPage(authUser: IUserMe, currentPath: string): string {
    if (currentPath !== PATH.SIGN_IN) {
        return currentPath;
    }
    if (isAdmin(authUser)) {
        return PATH.PAYMENTS;
    }
    if (authUser.permissions.includes(PERMISSION.PAYMENTS_VIEW)) {
        return PATH.PAYMENTS;
    }
    if (authUser.permissions.includes(PERMISSION.ACCOUNTS_VIEW)) {
        return PATH.ACCOUNTS;
    }
    if (authUser.permissions.includes(PERMISSION.PAYMENT_METHODS_VIEW)) {
        return PATH.PAYMENT_METHODS;
    }
    if (authUser.permissions.includes(PERMISSION.MERCHANTS_VIEW)) {
        return PATH.MERCHANTS;
    }

    return PATH.SETTINGS;
}
